// Built-in import
import * as React from "react"

// External import
import { SxProps, useTheme } from "@mui/material"

import ChildrenDefaultEvent from "./childrens/default"
import ChildrenStructureTitle from "./children-structure"
import DollarIcon from "@/components/icons/dollar-icon"

import { IEvent } from "@/types/event"
import LaunchIcon from "@mui/icons-material/Launch"
import StructureCard from "./structure-card"
// Internal import

import { humanDate } from "@/utils"
import { useTranslation } from "react-i18next"
import TextSnippetOutlinedIcon from "@mui/icons-material/TextSnippetOutlined";
import ErrorIcon from "@mui/icons-material/Error"; // Import the danger icon (ErrorIcon)
import { ASSETS_URL } from "@/constants"
import { useThemeConfig } from "@/context/theme"


interface IEventCard {
  item: IEvent
  sxProps?: SxProps
}

const EventCard: React.FC<IEventCard> = ({ item, sxProps }) => {

  // Getting translation object
  const { t } = useTranslation(["common"])
  // getting status as item
  const { status } = item
  // Getting theme mui
  const theme = useTheme()
  // icon card
  let cardIcon: React.ReactElement
  // bg color
  let cardBgColor: string
  // meta card
  let childrenCard: React.ReactNode
  // switch case status

  cardIcon = <ErrorIcon />
  cardBgColor = theme.palette.error.main
  childrenCard = (
    <ChildrenStructureTitle
      event={item}
      cardTitle={`${t("common:date")}:`}
      cardMeta={humanDate(item.custom_date ? item.custom_date : item.created_at)}
      cardType={item.type}
    >
      <ChildrenDefaultEvent item={item} />
    </ChildrenStructureTitle>
  )


  const { themeConfig } = useThemeConfig()


  if (item.type === "News") {
    return (
      <StructureCard
        cardBgColor={item.done ? theme.palette.primary.main : theme.palette.grey[400]}
        cardIcon={
          <img
            src={themeConfig?.config?.media?.calender_svg}
            alt="News Icon"
            style={{
              width: 24,
              height: 24,
              filter: "invert(100%)", // makes the icon white
            }}
          />
        }
        sxProps={sxProps}
      >
        {childrenCard}
      </StructureCard>
    )
  } else {
    let userCardIcon = <></>
    let useCardBgColor = item.done ? theme.palette.info.light : "#bdbdbd"
    switch (item.type) {
      case "Finance":
        userCardIcon = <DollarIcon color={theme.palette.common.white} />
        break
      case "Report":
        userCardIcon = <TextSnippetOutlinedIcon />
        useCardBgColor = "rgb(135, 42, 178)"
        break
      case "early_settlement":
        userCardIcon = <ErrorIcon />
        useCardBgColor = theme.palette.error.main
        break
      default:
        userCardIcon = <LaunchIcon />
    }
    return (
      <StructureCard
        cardBgColor={useCardBgColor}
        cardIcon={userCardIcon}
        sxProps={sxProps}
      >
        {childrenCard}
      </StructureCard>
    )
  }
}

export default EventCard
